import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

export default function Doe({
  deviceId,
  boolDoeSentDate,
  setBoolDoeSentDate,
  doeSentDate,
  setDoeSentDate,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Date d'envoie du DOE"
                value={doeSentDate && new Date(doeSentDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setDoeSentDate(null);
                  } else setDoeSentDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
      </Grid>
    </MDBox>
  );
}
